import React from 'react'

import closeIcon from '../../assets/icons/close.svg'
import searchIcon from '../../assets/icons/search.svg'

import Button from '../button'
import Icon from '../icon'
import InputField from '../input-field'

type Props = Omit<
  React.ComponentProps<typeof InputField>,
  'action' | 'type' | 'icon' | 'mixedLabel' | 'mixed'
>

const SearchInputField = (props: Props) => {
  const hasValue = !!(props.value && props.value.length > 0)

  const handleOnClearClick = () => {
    if (props.onChange) {
      props.onChange('', props.name)
    }
  }

  return (
    <InputField
      {...props}
      type="text"
      icon={<Icon title="search" source={searchIcon} />}
      action={
        hasValue ? (
          <Button
            hierarchy="ghost-input-action"
            icon={<Icon title="clear" source={closeIcon} />}
            size={props.size}
            onClick={handleOnClearClick}
            disabled={props.disabled}
          />
        ) : undefined
      }
    />
  )
}

export default SearchInputField
